var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgStorage = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#storage_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.67 8A6.707 6.707 0 0 0 1.335 8m6.667-6.666a9.348 9.348 0 0 1 0 13.333 9.346 9.346 0 0 1 0-13.333ZM1.336 8.001h13.333Z",
  stroke: "currentColor",
  strokeWidth: 1.333,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "storage_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h16v16H0z"
})))));
export default SvgStorage;